module.exports = __webpack_public_path__ + "img/erqi1.bbdb4e7a.png";